import request from '@/utils/request';



export default {
    // 获取评价期列表
    getAllDate: (param) => {
        return request({
            url: `/appraise/AAA/appraisePeriod/AllList`,
            method: 'get',
            param: param
        });
    },
    // 获取AAA状态列表
    getAaaStatus: (param) => {
        return request({
            url: `/appraise/AAA/status/AllList`,
            method: 'get',
            param: param
        });
    },
    // 获取评分类型列表
    getTypeList: (param) => {
        return request({
            url: `/appraise/scoreTypeList`,
            method: 'get',
            param: param
        });
    },
    // 评分模板页面
    scoringTemQuery: (param) => {
        return request({
            url: `/appraise/template/pageList`,
            method: 'post',
            data: param
        });
    },
    // 评分模板批量复制
    copyTemData: (param) => {
        return request({
            url: `/appraise/template/copyBatch`,
            method: 'post',
            data: param
        });
    },
    delTemplate: (id) => {
        return request({
            url: `/appraise/template/delete/${id}`,
            method: 'get',
            param: id
        });
    },
    // 删除评分计算规则详情
    deleteBatch: (param, templateId) => {
        return request({
            url: `/appraise/calcRuleDetail/${templateId}/deleteBatch`,
            method: 'post',
            data: param
        });
    },
    // 保存评分计算规则详情
    editBatch: (param, ruleNo, templateId) => {
        return request({
            url: `/appraise/calcRuleDetail/${templateId}/editBatch${ruleNo}`,
            method: 'post',
            data: param
        });
    },
    // 评分模板计算规则详情
    calcRuleDetail: (param) => {
        return request({
            url: '/appraise/calcRuleDetail/' + `${param}` + '/list',
            //  url: `/appraise/calcRuleDetail/${param.ruleId}/list`,
            method: 'post',
            data: param
        });
    },
    // 评分模板详细信息
    getTemInfo: (param) => {
        return request({
            url: `/appraise/template/${param}`,
            method: 'get',
            param: param
        });
    },
    // 评分模板更新
    updataTemInfo: (param, id) => {
        return request({
            url: `/appraise/template/update/${id}`,
            method: 'post',
            data: param
        });
    }, // 评分模板新增
    addTemInfo: (param, id) => {
        return request({
            url: `/appraise/template/insert`,
            method: 'post',
            data: param
        });
    },

    //  查询评分模板详情列表
    getTemDataInfo: (param) => {
        return request({
            url: `/appraise/template/${param}/list`,
            method: 'get',
            param: param
        });
    },
    //  评分模板详情列表新增
    addTemData: (param, id) => {
        return request({
            url: `/appraise/template/${id}/insert`,
            method: 'post',
            data: param
        });
    },
    //  获取评分模板详情大类列表
    getParentCategoryList: (param) => {
        return request({
            url: `/appraise/template/${param}/getParentCategoryList`,
            method: 'get',
            param: param
        });
    },
    //  评分模板详情详细信息
    templateDetailInfo: (param) => {
        return request({
            url: `/appraise/template/${param.ttQspiAppraiseTemplateId}/${param.ttQspiAppraiseTemplateDetailId}`,
            method: 'get',
            param: param
        });
    },
    //  评分模板详情批量删除
    deleteTemInfo: (param, templateId) => {
        return request({
            url: `/appraise/template/${templateId}/deleteBatch`,
            method: 'post',
            data: param
        });
    },
    //  评分模板详情更新
    updataTemInfoData: (param, templateId, id) => {
        return request({
            url: `/appraise/template/${templateId}/update/${id}`,
            method: 'post',
            data: param
        });
    },
    //  评分模板详情更新/新增
    updataOrAddTemInfoData: (param, templateId) => {
        return request({
            url: `/appraise/template/${templateId}/edit`,
            method: 'post',
            data: param
        });
    },



}